"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trade = void 0;
const utils_1 = require("../../../utils");
const monetary_js_1 = require("@interlay/monetary-js");
const big_js_1 = __importDefault(require("big.js"));
const utils_2 = require("./utils");
class Trade {
    constructor(path, // Is empty array if no path was found.
    inputAmount, outputAmount) {
        this.path = path;
        this.inputAmount = inputAmount;
        this.outputAmount = outputAmount;
        const rawPrice = outputAmount.toBig().div(inputAmount.toBig());
        this.executionPrice = new monetary_js_1.MonetaryAmount(outputAmount.currency, rawPrice);
        this.priceImpact = utils_2.computePriceImpact(path, inputAmount, outputAmount);
    }
    /**
     * Comparator for 2 trades with same input and output.
     *
     * @param anotherTrade Trade to compare.
     * @returns true if `this` trade is better, false if `anotherTrade` is better.
     * @throws When provided trade has different input or output currency.
     */
    isBetter(anotherTrade) {
        if (anotherTrade === null) {
            return true;
        }
        if (!this.inputAmount.eq(anotherTrade.inputAmount) ||
            !utils_1.isCurrencyEqual(this.outputAmount.currency, anotherTrade.outputAmount.currency)) {
            throw new Error("Trade: isBetterThan: Comparing 2 different trades is not possible.");
        }
        if (!this.outputAmount.eq(anotherTrade.outputAmount)) {
            return this.outputAmount.gt(anotherTrade.outputAmount);
        }
        return this.priceImpact.lte(anotherTrade.priceImpact);
    }
    /**
     * Get minimum output amount for trade with provided maximum allowed slippage.
     *
     * @param {number} maxSlippage Maximum slippage in percentage.
     * @returns {MonetaryAmount<CurrencyExt>} Minimum output amount of trade allowed with provided slippage.
     */
    getMinimumOutputAmount(maxSlippage) {
        const maxSlippageInDecimal = maxSlippage / 100;
        const amount = big_js_1.default(1).sub(maxSlippageInDecimal).mul(this.outputAmount.toBig());
        const minimumAmountOut = new monetary_js_1.MonetaryAmount(this.outputAmount.currency, amount);
        return minimumAmountOut;
    }
}
exports.Trade = Trade;
//# sourceMappingURL=trade.js.map